import React from "react";
import styled from "styled-components";

export const inputWithLabel = (Component) => (props) => {
  return (
    <Container labelTop={props.labelTop} gap={props.gap}>
      <LabelStyle htmlFor={props.id} title={props.title}>
        {props.label}
      </LabelStyle>
      <Component {...props} />
    </Container>
  );
};

const Container = styled.div`
  position: relative;
  width: 100%;
  display: ${(props) => (props.labelTop ? "grid" : "flex")};
  gap: ${(props) => props.gap};
`;
const LabelStyle = styled.label`
  white-space: nowrap;
  display: flex;
  align-items: center;
`;
